'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'beer-mug-empty';
var width = 576;
var height = 512;
var aliases = ["beer"];
var unicode = 'f0fc';
var svgPathData = 'M64 32l384 0 0 64 128 0 0 211.8-128 64 0 108.2-384 0 0-448zM448 300.2l64-32 0-108.2-64 0 0 140.2zM176 152l0-24-48 0 0 256 48 0 0-232zm104 0l0-24-48 0 0 256 48 0 0-232zm104 0l0-24-48 0 0 256 48 0 0-232z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBeerMugEmpty = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;